const configuredApiBaseUrl = String(process.env.REACT_APP_API_BASE_URL || "")
  .trim()
  .replace(/\/+$/, "");
const isLocalBrowser = ["localhost", "127.0.0.1"].includes(
  window.location.hostname
);
const configuredApiIsLocal =
  /^https?:\/\/(localhost|127\.0\.0\.1)(:\d+)?$/i.test(configuredApiBaseUrl);
const runtimeApiBaseUrl = isLocalBrowser
  ? configuredApiBaseUrl || "http://localhost:5003"
  : configuredApiIsLocal || !configuredApiBaseUrl
    ? `${window.location.origin}/api`
    : configuredApiBaseUrl;

const config = {
  API_BASE_URL: runtimeApiBaseUrl,

  

  PATIENT: {
    LOGIN: "/patient/login",
    REGISTER: "/patient/register",
    COMPLETE_PROFILE: "/patient/complete-profile",
    PROFILE: "/patient/profile",
    PROFILE_PICTURE: "/patient/profile-picture"
  }

};

export default config;
